import React from 'react';
import type { UseFormReturn } from 'react-hook-form';
import { InputText, useWizard } from '@goodfynd/react-web.lib.forms';

import GeoInput from '../../../forms/GeoInput';
import type { EventLocationFormFields } from '../types';
const EventLocation = ({ control }: UseFormReturn<EventLocationFormFields>) => {
  const { isEditing } = useWizard();
  return (
    <div>
      <GeoInput
        control={control}
        disabled={isEditing}
        lookup
        name="location"
        showAddressFields
        showMap
      />

      <InputText
        control={control}
        helperText="Please secure a spot for the food truck to park and leave directions here"
        label="Parking Instructions"
        multiline
        name="parkingInstructions"
      />
    </div>
  );
};

export default EventLocation;
